/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-10-29 07:49:44
 *
 *******************************************************/
// @flow

// Display 10 product ranking per page
export const NUMBER_PRODUCT_RANKING_PER_PAGE = 10;

export const RANKING_TYPE = [
  { value: '', label: 'AdminHTML.ProductRanking.Constant.rankingType1_Label' },
  { value: 'alwaysPrioritized', label: 'AdminHTML.ProductRanking.Constant.rankingType2_Label' },
  { value: 'matchedSearch', label: 'AdminHTML.ProductRanking.Constant.rankingType3_Label' },
  { value: 'keywordSearch', label: 'AdminHTML.ProductRanking.Constant.rankingType4_Label' },
  { value: 'atTheBottom', label: 'AdminHTML.ProductRanking.Constant.rankingType5_Label' }
];

export const DATE_RANGE = [
  { value: 'none', label: 'AdminHTML.ProductRanking.Constant.dateRange1_Label' },
  { value: 'today', label: 'AdminHTML.ProductRanking.Constant.dateRange2_Label' },
  { value: 'tomorrow', label: 'AdminHTML.ProductRanking.Constant.dateRange3_Label' },
  { value: 'nextWeek', label: 'AdminHTML.ProductRanking.Constant.dateRange4_Label' },
  { value: 'nextMonth', label: 'AdminHTML.ProductRanking.Constant.dateRange5_Label' },
  { value: 'custom', label: 'AdminHTML.ProductRanking.Constant.dateRange6_Label' }
];
